import { StringColumn } from 'baseui/data-table';

export const columnConfigs = [
	StringColumn({
		title: 'Service Keys',
		width: 300,
		mapDataToValue: (data: any) => data.label
	})
];

export default columnConfigs;
